import { gatewayConstants } from '../constants';

export function gateways(state = {}, action) {
  switch (action.type) {
    case gatewayConstants.GETALL_REQUEST:
      return {
        state,
        loading: true,
      };
    case gatewayConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false,
      };
    case gatewayConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function AddGateway(state = {}, action) {
  switch (action.type) {
    case gatewayConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      };
    case gatewayConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false,
      };
    case gatewayConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false,
      };
    default:
      return state;
  }
}

export function GetGateway(state = {}, action) {
  switch (action.type) {
    case gatewayConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      };
    case gatewayConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false,
      };
    case gatewayConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateGateway(state = {}, action) {
  switch (action.type) {
    case gatewayConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      };
    case gatewayConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false,
      };
    case gatewayConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false,
      };
    default:
      return state;
  }
}
